<div class="position-relative">

  <ngx-spinner name="spModificarTipoMovimiento" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-lg-6">
        <mat-form-field>
          <input placeholder="Descripción" type="text" formControlName="Descripcion" matInput>
          <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
        </mat-form-field>
      </div>
      <div class="col-lg-6">
        <mat-slide-toggle matTooltip="Resta/Descuenta" style="padding-top: 10px;"
          formControlName="Resta">Resta/Descuenta</mat-slide-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <mat-slide-toggle style="padding-top: 10px;" matTooltip="Es anulable" formControlName="EsAnulable">Es
          anulable</mat-slide-toggle>
      </div>
      <div class="col-lg-6">
        <mat-slide-toggle style="padding-top: 10px;" matTooltip="Tiene comisión" formControlName="TieneComision">Tiene
          comisión</mat-slide-toggle>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <!-- Guarda el nombre del icono de Material que se muestra en las grillas
             de movimientos. Ver component/selector-icono. -->
        <app-selector-icono formControlName="Icono" etiqueta="Icono"
          ayuda="Se muestra en el listado de movimientos junto a cada registro de este tipo.">
        </app-selector-icono>
      </div>
    </div>

    <br>
    <mat-divider></mat-divider>
    <br>
    <div class="row">
      <div class="col-lg-3">
        <button mat-raised-button color="primary" *appRole="['TiposMovimiento.Modificar']" (click)="doAction()"
          [disabled]="!form.valid">Modificar</button>
      </div>
      <div class="col-lg-3">
        <button mat-button (click)="closeDialog()" mat-flat-button color="warn">Cancelar</button>
      </div>
    </div>
  </form>
</div>
